import useFacilityData from '@usas/ui-web/state/facility/UseFacilityData';

const useFacilityPoolsDetail = () => {
  const { facilityState } = useFacilityData();

  return {
    facilityState
  };
};

export default useFacilityPoolsDetail;